import Model, { attr } from '@ember-data/model';
import { type AccessLevel } from 'uplisting-frontend/models/airbnb-official-connection';

export default class AirbnbOfficialUpgradeModel extends Model {
  @attr('string') code!: string;
  @attr('string') accessLevel!: AccessLevel;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-upgrade': AirbnbOfficialUpgradeModel;
  }
}
